import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-tournament-scoreboard',
    templateUrl: 'tournament-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class TournamentScoreboardComponent {
    @Input() event: EventModel;

    constructor(public siteCore: Sitecore) {}

    get eventName(): string {
        return this.event.name;
    }
}
